var React = require('react');
import { checkUserRegister, signin } from '../actions/LoginServiceCreator';
import Facebook from './Facebook';
var cookie = require('react-cookie');

class Login extends React.Component {
  static contextTypes = {
    executeAction: React.PropTypes.func
  }
  render() {
    if (cookie.load('logged_in') === 1) {
      window.location.href = '/';
      return;
    }
    return (
      <div>
        <div className="container_fluid main_container second-section login-container" id="content">
          <div className="row-fluid clearfix login-innercontainer">
            <div className="logged-container">
              <div className="login-content">
                <div className="login-title">
                  Delivering the top rated venues,hotels,
                  <br/> products and services to you
                </div>
                <div className="login-types clearfix">
                  <div className="signup-container" style={ { "float": "left", "border-right": "1px solid #ffffff" } }>
                    <div className="signup-title">
                      <input type="email" className="input-email input-box" placeholder="Email" />
                    </div>
                    <div className="signup-title">
                      <input type="password" className="input-pass input-box" placeholder="Password" />
                    </div>
                    <div className="signup-title">
                      <div className="complete item-btn sigin-key" onClick={ this.login.bind(this) } style={ { "width": "12.5em !important", "margin-bottom": "2em" } }>Login</div>
                    </div>
                    <div className="login-error"></div>
                  </div>
                  <div className="signup-container" style={ { "float": "right" } }>
                    <div className="signup-title">
                      <div className="social-signup-btn">
                        <Facebook loginHandler={ this.validatelogin.bind(this) } />
                      </div>
                    </div>
                    <div className="or-text"><span>or</span></div>
                    <div className="signup-title" style={ { "margin-top": "0em" } }>
                      <a href="/signup" className="social-signup-btn">
                        <div className="signupemail social-login"></div>
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      );
  }
  validatelogin(response) {
    response.sessionid = cookie.load('sid');
    response.ip = cookie.load('ip');
    response.is_fb_login = 1;
    response.is_gmail_login = 0;
    response.is_twitter_login = 0;
    response.is_linkedin_login = 0;
    this.context.executeAction(checkUserRegister, response);
  }
  login(response) {
    var email = document.getElementsByClassName('input-email')[0].value;
    var password = document.getElementsByClassName('input-pass')[0].value;
    if (email == "") {
      $('.login-error').text("Error: email cannot be blank!");
      $(".input-email").focus();
      return false;
    } else if (password == "") {
      $('.login-error').text("Error: password cannot be blank!");
      $(".input-pass").focus();
      return false;
    }
    var data = {
      email,
      password
    };
    $(".whirly-loader").css('visibility', 'visible');
    this.context.executeAction(signin, data);
  }
}

module.exports = Login;




// WEBPACK FOOTER //
// ./src/components/Login.js